<script lang="ts" setup="">
import Popper from 'vue3-popper'
import { computed, ref, type StyleValue, watch } from 'vue'
import { onClickOutside, useElementBounding } from '@vueuse/core'

const {
  disabled = false,
  persistent = false,
  isSameWidthAsParent = true,
  placement = 'bottom-start',
  width,
} = defineProps<{
  disabled?: boolean
  persistent?: boolean
  width?: string
  isSameWidthAsParent?: boolean
  placement?:
    | 'auto'
    | 'auto-start'
    | 'auto-end'
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'right'
    | 'right-start'
    | 'right-end'
    | 'left'
    | 'left-start'
    | 'left-end'
}>()

const active = defineModel<boolean>({ default: false })
const wrapperElement = ref<HTMLDivElement | undefined>()
const wrapperBounding = useElementBounding(wrapperElement)
const popoverElement = ref<HTMLDivElement | undefined>()

function activate() {
  if (disabled) return
  active.value = true
}

function close() {
  if (persistent) return
  active.value = false
}

watch(active, value => {
  if (value) {
    onClickOutside(popoverElement, close)
  }
})

const popperWidth = computed((): StyleValue => {
  return { width: width ? width : isSameWidthAsParent ? `${wrapperBounding.width.value}px` : 'auto' }
})
</script>

<template>
  <div
    class="relative"
    ref="wrapperElement"
    data-test="popover-wrapper"
  >
    <Popper
      content="This is the popper content"
      class="block!"
      :show="active"
      flip
      arrow
      :placement="placement"
      data-test="popper"
    >
      <slot
        name="activator"
        :active="active"
        :activate="activate"
      />
      <template #content>
        <Transition name="v-popover">
          <div
            v-if="active"
            ref="popoverElement"
            class="rounded border border-general-strong bg-general-base shadow-neutral"
            :style="popperWidth"
            data-test="popover-content"
          >
            <slot :close="close" />
          </div>
        </Transition>
      </template>
    </Popper>
  </div>
</template>

<style scoped>
.v-popover-enter-from,
.v-popover-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

.v-popover-enter-to,
.v-popover-leave-from {
  opacity: 1;
  transform: scale(1);
}

.v-popover-enter-active,
.v-popover-leave-active {
  transition:
    100ms ease-in-out opacity,
    100ms ease-in-out transform;
  transform-origin: top;
}
</style>

<!--<script lang="ts" setup>-->
<!--import { nextTick, reactive, ref, watch } from 'vue'-->
<!--import { onClickOutside, useElementBounding, useElementSize, useWindowSize } from '@vueuse/core'-->
<!--import { onScrollOutside } from '@/composables/onScrollOutside.ts'-->
<!--import { useElementOverflow } from '@/composables/useElementOverflow.ts'-->

<!--const {-->
<!--  disabled = false,-->
<!--  popoverWidth = undefined,-->
<!--  offsetY = 4,-->
<!--  popoverPlacement = 'left',-->
<!--  persistent = false,-->
<!--  fixed = false,-->
<!--} = defineProps<{-->
<!--  disabled?: boolean-->
<!--  popoverWidth?: number-->
<!--  popoverPlacement?: 'left' | 'right'-->
<!--  offsetY?: number-->
<!--  persistent?: boolean-->
<!--  fixed?: boolean-->
<!--}>()-->

<!--const active = defineModel<boolean>({ default: false })-->
<!--const wrapperElement = ref<HTMLDivElement | undefined>()-->
<!--const popoverElement = ref<HTMLDivElement | undefined>()-->

<!--const position = reactive({-->
<!--  width: '',-->
<!--  top: '',-->
<!--  left: '',-->
<!--  right: '',-->
<!--  bottom: '',-->
<!--})-->

<!--function toggleActive() {-->
<!--  if (!disabled) {-->
<!--    active.value = !active.value-->
<!--  }-->
<!--}-->

<!--function close() {-->
<!--  if (!persistent) {-->
<!--    active.value = false-->
<!--  }-->
<!--}-->

<!--const windowSize = useWindowSize()-->
<!--const wrapperBounding = useElementBounding(wrapperElement)-->

<!--const setPosition = async (): Promise<void> => {-->
<!--  const { width, height } = useElementSize(wrapperElement)-->

<!--  if (!fixed) {-->
<!--    if (popoverPlacement === 'left') {-->
<!--      position.left = `0`-->
<!--    } else {-->
<!--      position.right = '0'-->
<!--    }-->
<!--    position.top = `calc(100% + ${offsetY}px)`-->
<!--    position.width = `${popoverWidth ?? width.value}px`-->

<!--    await new Promise(resolve => setTimeout(resolve, 100))-->

<!--    const { height: popoverHeight } = useElementSize(popoverElement)-->

<!--    console.log(popoverHeight)-->

<!--    const popoverOverflowing = useElementOverflow(popoverElement)-->

<!--    if (popoverOverflowing.value) {-->
<!--      position.top = ''-->
<!--      position.bottom = `calc(100% + ${offsetY}px)`-->
<!--    }-->

<!--    return-->
<!--  }-->

<!--  position.width = `${popoverWidth ?? width.value}px`-->
<!--  position.top = `${wrapperBounding.y.value + height.value + Math.abs(offsetY)}px`-->

<!--  if (popoverPlacement === 'left') {-->
<!--    position.left = `${wrapperBounding.x.value}px`-->
<!--  } else {-->
<!--    position.left = `${wrapperBounding.x.value - (popoverWidth ?? width.value) + width.value}px`-->
<!--  }-->

<!--  await nextTick()-->

<!--  const { height: popoverHeight } = useElementSize(popoverElement)-->

<!--  const popoverOverflowing = useElementOverflow(popoverElement)-->

<!--  if (popoverOverflowing.value) {-->
<!--    position.top = `${wrapperBounding.top.value - popoverHeight.value}px`-->
<!--  }-->
<!--}-->

<!--watch(active, setPosition)-->

<!--watch(active, value => {-->
<!--  if (value) {-->
<!--    onClickOutside(popoverElement, close)-->
<!--    onScrollOutside(wrapperElement, close)-->
<!--  }-->
<!--})-->

<!--watch([windowSize.width, windowSize.height], setPosition)-->
<!--</script>-->

<!--<template>-->
<!--  <div-->
<!--    ref="wrapperElement"-->
<!--    class="relative"-->
<!--  >-->
<!--    <slot-->
<!--      :activate="toggleActive"-->
<!--      :active="active"-->
<!--      name="activator"-->
<!--    />-->
<!--    <Transition name="v-popover">-->
<!--      <Teleport-->
<!--        v-if="fixed"-->
<!--        to="body"-->
<!--      >-->
<!--        <div-->
<!--          v-if="active"-->
<!--          class="z-[9999] rounded border-1 border-general-strong bg-general-base shadow-neutral"-->
<!--          :class="fixed ? 'fixed' : 'absolute'"-->
<!--          :style="position"-->
<!--          ref="popoverElement"-->
<!--        >-->
<!--          <slot :close="close" />-->
<!--        </div>-->
<!--      </Teleport>-->
<!--      <div-->
<!--        v-else-if="active"-->
<!--        class="z-[9999] rounded border-1 border-general-strong bg-general-base shadow-neutral"-->
<!--        :class="fixed ? 'fixed' : 'absolute'"-->
<!--        :style="position"-->
<!--        ref="popoverElement"-->
<!--      >-->
<!--        <slot :close="close" />-->
<!--      </div>-->
<!--    </Transition>-->
<!--  </div>-->
<!--</template>-->

<!--<style>-->
<!--.v-popover-enter-from,-->
<!--.v-popover-leave-to {-->
<!--  opacity: 0;-->
<!--  transform: scale(0.9);-->
<!--}-->

<!--.v-popover-enter-to,-->
<!--.v-popover-leave-from {-->
<!--  opacity: 1;-->
<!--  transform: scale(1);-->
<!--}-->

<!--.v-popover-enter-active,-->
<!--.v-popover-leave-active {-->
<!--  transition:-->
<!--    100ms ease-in-out opacity,-->
<!--    100ms ease-in-out transform;-->
<!--  transform-origin: top;-->
<!--}-->
<!--</style>-->
